var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#716E6E",
    d: "M18.8281 0.976562H1.17188C0.525703 0.976562 0 1.50227 0 2.14844V13.7891C0 14.4352 0.525703 14.9609 1.17188 14.9609H6.91406V17.8516H3.75C3.42641 17.8516 3.16406 18.1139 3.16406 18.4375C3.16406 18.7611 3.42641 19.0234 3.75 19.0234H16.25C16.5736 19.0234 16.8359 18.7611 16.8359 18.4375C16.8359 18.1139 16.5736 17.8516 16.25 17.8516H13.0859V14.9609H18.8281C19.4743 14.9609 20 14.4352 20 13.7891V2.14844C20 1.50227 19.4743 0.976562 18.8281 0.976562ZM11.9141 17.8516H8.08594V14.9609H11.9141V17.8516ZM18.8281 13.7891C18.3142 13.7891 1.58375 13.7891 1.17188 13.7891V2.14844H18.8281C18.8289 14.0419 18.832 13.7891 18.8281 13.7891Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.75e41a542b2ad32225faec1a3c1c51e3.svg";
export { ForwardRef as ReactComponent };